module.exports = __webpack_public_path__ + "img/icone-lixeira.27ba2995.svg";